const { search: queryParams } = document.location;

if (queryParams.length > 0 && queryParams.includes('utm_')) {
  window.localStorage.setItem('savedQueryParams', queryParams.slice(1));
}
